<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col md:w-1/6 w-full">
          <h6 class="mb-2">Código do Pedido</h6>
          <vs-input class="w-full" v-model="idOrder" />
        </div>
        <div class="vx-col md:w-1/6 w-full">
          <h6 class="mb-2">Empresa</h6>
          <v-select :options="['Regnaparts','Revestebem']" v-model="company" />
        </div>
        <div class="vx-col md:w-1/6 w-full">
          <h6 class="mb-4">Calcular ST</h6>
          <div class="con-s">
            <vs-switch color="success" v-model="calculateST">
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap items-center" slot="footer">
        <vs-button class="mr-6" @click="generateOrderPdf()">Gerar PDF</vs-button>
      </div>
    </vx-card>
    <OrderPdf ref="orderPdf" />
  </div>
</template>
<script>
// import axios from 'axios'
// import { baseApiUrl } from "@/global"
import OrderPdf from "./OrderPdf.vue"

export default {
  data() {
    return {
      idOrder: null,
      company: 'Regnaparts',
      calculateST: true,
    }
  },
  components: {
    OrderPdf,
  },
  methods: {
    async generateOrderPdf() {
      try {
        await this.$refs.orderPdf.generate(this.idOrder, this.company, this.calculateST)
      } catch (error) {
        console.log(error);
        if (error.response && error.response.status == 400) {
          this.$vs.notify({
            title: 'Erro',
            text: 'Pedido não encontrado',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      }
    }
  }
}

</script>
